import { Box, Typography } from "@mui/material";
import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const IncidentPieChart = ({ categoryCount }) => {
  const COLORS = [
    "#4BC0C0", // Schema Drift (Teal)
    "#FF9F40", // Volume (Orange)
    "#FF6384", // Freshness (Pink/Red)
    "#36A2EB", // Field Health (Blue)
    "#9966FF", // Custom (Purple)
    "#FF6B6B", // Job Failure (Red)
    "#4ECDC4", // Accuracy (Light Teal)
    "#FFE66D", // Completeness (Yellow)
    "#95E1D3", // Consistency (Mint)
    "#F38181", // Validity (Light RedObject.entries(categoryCount).map(([category, count], index) => {


  ];

  const chartData = useMemo(() => {
    const entries = Object.entries(categoryCount).filter(
      ([name]) => name !== "totalIncidents"
    );

    return {
      series: entries.map(([, value]) => value),
      labels: entries.map(([name]) => name),
    };
  }, [categoryCount]);

  // Get total incidents from the object or calculate it
  const totalIncidents = useMemo(() => {
    return (
      categoryCount.totalIncidents ||
      Object.entries(categoryCount)
        .filter(([name]) => name !== "totalIncidents")
        .reduce((sum, [, value]) => sum + value, 0)
    );
  }, [categoryCount]);

  // If no data, return null
  if (totalIncidents === 0) {
    return null;
  }

  const chartOptions = {
    chart: {
      type: "pie",
    },
    labels: chartData.labels,
    colors: COLORS,
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val.toFixed(0) + "%";
      },
    },
    tooltip: {
      y: {
        formatter: function (value) {
          const percentage = ((value / totalIncidents) * 100).toFixed(1);
          return `${value} (${percentage}%)`;
        },
      },
    },
    responsive: [
      {
        breakpoint: 1024,
        options: {
          chart: {
            width: 200,
            height: 200,
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: {
            width: 180,
            height: 180,
          },
        },
      },
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 150,
            height: 150,
          },
        },
      },
    ],
  };

  return (
    <div className="grid grid-cols-3 gap-4 mb-3">
      {
        Object.entries(categoryCount)
        .sort(([a], [b]) => {
          if (a === "Total Incidents") return -1;
          if (b === "Total Incidents") return 1;
          return 0;
        })
        .map(([category, count], index) => {
          const isTotal = category === "Total Incidents";

          const percentage = !isTotal
            ? ((count / categoryCount["Total Incidents"]) * 100).toFixed(0)
            : null;

    const color = COLORS[index % COLORS.length];
        return (
          <Box
            key={category}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "16px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
              padding: 3,
              height: "120px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              border: `1px solid  ${color}`,
              transition: "all 0.3s ease",
              cursor: "pointer",
              "&:hover": {
                boxShadow: "0 12px 30px rgba(0, 0, 0, 0.2) !important",
                transform: "translateY(-6px) !important",
                border: "1px solid #EDE9FE !important",
                backgroundColor: "#f8f9ff",
              },
            }}
          >
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 600,
                  color: color,
                  fontSize: "1.1rem",
                }}
              >
              {isTotal ? category : `${category} (${percentage}%)`}
              </Typography>
              <Box
                sx={{
                  height: "3px",
                  width: "40px",
                  backgroundColor: color,
                  borderRadius: "2px",
                  mt: 0.5,
                }}
              />
            </Box>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: color,
                fontSize: "2rem",
              }}
            >
              {count}
            </Typography>
          </Box>
        );
      })}
    </div>
  );
};

export default IncidentPieChart;
